import { render } from "./Family.vue?vue&type=template&id=a5f08986&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"

import "./Family.vue?vue&type=style&index=0&id=a5f08986&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f08986"]])

export default __exports__